/**
 * Dermatologically Tested Badge
 * 
 * Uses the provided badge image (WebP) with responsive srcset.
 * Size is controlled via className — do NOT pass inline width/height
 * so Tailwind responsive classes work properly.
 */

interface DermatologicallyTestedBadgeProps {
  size?: number;
  className?: string;
}

const BADGE_SRC = 'https://d2xsxph8kpxj0f.cloudfront.net/310519663243023818/kXYViC6LoVarhABtxw9dmA/derm-badge-200_c9861cf8.webp';
const BADGE_SRCSET = [
  'https://d2xsxph8kpxj0f.cloudfront.net/310519663243023818/kXYViC6LoVarhABtxw9dmA/derm-badge-100_b3700a07.webp 100w',
  'https://d2xsxph8kpxj0f.cloudfront.net/310519663243023818/kXYViC6LoVarhABtxw9dmA/derm-badge-200_c9861cf8.webp 200w',
  'https://d2xsxph8kpxj0f.cloudfront.net/310519663243023818/kXYViC6LoVarhABtxw9dmA/derm-badge-400_939a023d.webp 400w',
  'https://d2xsxph8kpxj0f.cloudfront.net/310519663243023818/kXYViC6LoVarhABtxw9dmA/derm-badge_4fbd88e1.webp 600w',
].join(', ');

export function DermatologicallyTestedBadge({ size = 140, className = '' }: DermatologicallyTestedBadgeProps) {
  return (
    <div className={className}>
      <img
        src={BADGE_SRC}
        srcSet={BADGE_SRCSET}
        sizes={`${size}px`}
        alt="Dermatologically Tested"
        width={size}
        height={size}
        loading="eager"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
    </div>
  );
}

export default DermatologicallyTestedBadge;
